import HTTPClient, { HTTPClientParameters } from './HTTPClient';
import { PagedResponse } from 'types/Pagination';
import { Visitor } from 'types/Visitor';

type VisitorClientParams = HTTPClientParameters;

// comes from backend/spots/api/views/visitor_viewset.py
export const VISITOR_PAGE_SIZE = 20;

export type PaginatedVisitors = PagedResponse<Visitor>;

export type VisitorCreateOrEditPayload = {
    codes?: string[];
    phone?: string;
    plate: string;
    spot: number;
    state: string;
    country: string;
    validation_source?: string;
    name?: string;
};

type VisitorValidationPayload = {
    visitor_pk: number;
    minutes: number;
    validation_source: string;
};

type UploadVisitorsCSVResponse = {
    result: string;
    message: string;
};

type ProgressUploadVisitorsCSVResponse = {
    result: string;
    progress: { value: number; max: number };
};

class VisitorClient extends HTTPClient {
    constructor(params: VisitorClientParams) {
        super(params);
        this.headers.set('Content-Type', 'application/json');
    }
    getVisitors(spot: number, page: number = 1, expiring?: boolean, searchTerm?: string): Promise<PaginatedVisitors> {
        let url = `visitors?spot=${spot}&page=${page}`;
        if (expiring) url += '&expiring=True';
        if (searchTerm) url += `&search=${searchTerm}`;
        return this.get(url);
    }
    addVisitor(visitorInfo: VisitorCreateOrEditPayload): Promise<Visitor> {
        return this.post(`visitors/`, visitorInfo);
    }
    editVisitor(visitorInfo: VisitorCreateOrEditPayload, pk: number): Promise<Visitor> {
        return this.patch(`visitors/${pk}/`, visitorInfo);
    }
    deleteVisitor(pk: number): Promise<unknown> {
        return this.delete(`visitors/${pk}/`);
    }
    uploadVisitorsCSV(body: {
        code: string;
        file: File;
        spot: number;
        csv_url: string;
    }): Promise<UploadVisitorsCSVResponse> {
        return this.post(`visitors_csv`, body);
    }
    progressUploadVisitorsCSV(spot: number): Promise<ProgressUploadVisitorsCSVResponse> {
        return this.get(`visitors_csv?spot=${spot}`);
    }
    getVisitorsForKiosk(spot: number): Promise<Visitor[]> {
        return this.get(`spots/${spot}/visitors/`);
    }
    validateKioskVisitor(validation: VisitorValidationPayload): Promise<{ result: string; plate: string }> {
        return this.post(`validate`, validation);
    }
}

export default VisitorClient;
